import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_j58tygnzmp: FaireBrandEntity = {
  token: "b_j58tygnzmp",
  type: "brand",
  name: "Solemare",
  avatarUrl:
    "https://cdn.faire.com/fastly/7a3cfbeb995044b82c1e2515c5b33225cbe18635b1e939113001fd09a58fbbb7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f405b643553c0517ab897703633d03c732959a18d55b1890e579699541c9f5ed.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7a3cfbeb995044b82c1e2515c5b33225cbe18635b1e939113001fd09a58fbbb7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f405b643553c0517ab897703633d03c732959a18d55b1890e579699541c9f5ed.png",
  location: "Los Alamitos, CA, USA",
  minimumOrderDollars: 137,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Founded in 2023, Solemareny is a brand synonymous with easy style and versatile wardrobe essentials. We began our journey with a mission to provide high-quality maternity wear that transitions seamlessly into everyday life. Our collections are inspired by the bohemian spirit and the need for comfortable yet chic loungewear and vacation outfits. We pride ourselves on sourcing and creating our pieces right here in the USA, supporting local craftsmanship and quality. At Solemareny, we are committed to offering fashion that caters to the modern lifestyle, encouraging you to express your unique style effortlessly.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:03.066Z",
    importedBy: "entity-db-cli",
  },
};
